module.exports = __webpack_public_path__ + "static/media/29COICT8.3ea6178c.jpg";